<template>
    <ChartBlock :data="data" v-if="isLoading" />
    <LoadingWrap v-else />
</template>

<script>
import { getDartData } from '@/api';
import ChartBlock from '@/components/ChartBlock.vue';
import LoadingWrap from '@/components/LoadingWrap.vue';

export default {
    components: {
        ChartBlock,
        LoadingWrap,
    },
    data() {
        return {
            isLoading: false,
            data: {
                unit: '천원',
                step: 150000000,
                type: [
                    {
                        name: '자산총계',
                        type: 'line',
                        color: '#5f48c4',
                        data: [],
                    },
                    {
                        name: '유동자산',
                        type: 'bar',
                        color: ['#fac438', '#f7d57d'],
                        data: [],
                    },
                    {
                        name: '비유동자산',
                        type: 'bar',
                        color: ['#f96835', '#f99571'],
                        data: [],
                    },
                    {
                        name: '유동부채',
                        type: 'bar',
                        color: ['#21c389', '#78d1b1'],
                        data: [],
                    },
                    {
                        name: '자본총계',
                        type: 'bar',
                        color: ['#446bc2', '#7793d1'],
                        data: [],
                    },
                ],
                years: [],
            },
        };
    },
    async mounted() {
        const {
            data: { BS },
        } = await getDartData();
        const modifyData = Object.keys(BS).reduce(
            (acc, key) => {
                Object.entries(BS[key]).forEach((entrie) => {
                    if (!acc.years.includes(entrie[0])) acc.years.push(entrie[0]);
                    if (!acc.type[key]) {
                        acc.type[key] = [entrie[1]];
                    } else {
                        acc.type[key].push(entrie[1]);
                    }
                });
                return acc;
            },
            {
                type: {},
                years: [],
            }
        );

        this.data.type[0].data = modifyData.type.assets; //자산총계
        this.data.type[1].data = modifyData.type.currentAssets; //유동자산
        this.data.type[2].data = modifyData.type.noncurrentAssets; //비유동자산
        this.data.type[3].data = modifyData.type.currentLiabilities; //유동부채
        this.data.type[4].data = modifyData.type.equity; //자본총계
        this.data.years = modifyData.years;

        this.isLoading = true;
    },
};
</script>

<style></style>
